<script lang="ts">
	//Services/Utils
	import { createEventDispatcher } from 'svelte';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { format } from 'svelte-i18n';
	import { capFirstChar } from 'src/helpers/utilities';

	//Components
	import { Container, Text, Token } from '@Shelly/shelly-design-system/index';

	//Helpers
	import { getDevicePropertyOptions } from 'src/components/Scenes/helpers/math_based/math_param_utils';

	export let selectedDevice: { id: string } = null;
	export let selectedProperty: string = null;

	$: devicePropsOptions = selectedDevice ? getDevicePropertyOptions(selectedDevice.id) : [];

	const dispatch = createEventDispatcher();

	const handleSelect = (selected) => {
		dispatch('selectProperty', selected);
	};
</script>

<Container>
	<Text element="h2" class="mb-s">
		{$format('label_select_device_property', {
			default: 'Select device property',
		})}
	</Text>

	<div
		class={classMap({
			'd-flex flex-wrap': true,
		})}
		style="gap:var(--spacing-s)"
	>
		{#each devicePropsOptions as deviceProp}
			<Token
				id="token-nl3kn2f"
				title={capFirstChar(deviceProp.title)}
				class="text-capitalize"
				on:click={() => handleSelect(deviceProp?.value)}
				selected={selectedProperty === deviceProp?.value}
				disabled={deviceProp.disabled}
			/>
		{/each}
	</div>
</Container>
